module.exports = __webpack_public_path__ + "img/bchzd.8d57fc69.png";